import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { superstyled } from '@zenbusiness/zui/styles';

// Velo brand colors for CTA row
export const VELO_CTA_GRADIENT_START = '#E8F4F8';
export const VELO_CTA_GRADIENT_END = '#F0F7FA';

export const VeloCtaBackground = superstyled({
  tag: Box,
  styles: () => ({
    background: `linear-gradient(90deg, ${VELO_CTA_GRADIENT_START} 0%, ${VELO_CTA_GRADIENT_END} 100%)`,
    padding: '0.75rem 1rem',
  }),
});

// Matches the Amendment product pages' Ask Velo CTA (VeloBanner.styles.js)
export const ProductPageVeloCtaBackground = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.main,
    borderRadius: theme.shape.rounded.lg,
    border: `1px solid ${theme.palette.border.main}`,
    padding: theme.spacing(2),
  }),
});

// Wrapper to handle gradient border with border-radius, matches Amendment's ButtonWrapper
export const AskVeloButtonWrapper = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    display: 'inline-flex',
    position: 'relative',
    borderRadius: theme.shape.rounded.lg,
    background: 'linear-gradient(249.5deg, #3971E7 27.22%, #33F28B 100%)',
    padding: '2px',
  }),
});

export const AskVeloButton = superstyled({
  tag: Button,
  styles: ({ theme }) => ({
    borderRadius: '10px',
    padding: '6px 10px',
    backgroundColor: theme.palette.background.grey.light,
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.fontSize.sm,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: theme.palette.background.grey.dark,
      color: theme.palette.text.primary,
    },
  }),
});
